













































































import {Vue, Component, VModel, Prop} from 'vue-property-decorator';
import BTPortalCollapse from "@/components/common/BTPortalCollapse.vue";
import {
	SelectableServiceLogDTO,
	ServiceInvoice,
	ServiceRecordDTO
} from "@/components/payroll/business/services/ServiceDTO";
import moment from "moment/moment";
import SingleFileHolder from "@/components/util/SingleFileHolder.vue";
import {prettyEnum} from "@/utils/StringUtils";

@Component({
	methods: {prettyEnum},
	components: {SingleFileHolder, BTPortalCollapse}
})
export default class InvoiceCollapse extends Vue {

	@Prop()
	private invoice!: ServiceInvoice

	get invoiceDate(): string {
		return moment(this.invoice.invoiceDate).format("DD.MM.yyyy")
	}

	get statusColor(): string {
		switch (this.invoice.status) {
			case "DRAFT":
			case "IN_PROGRESS":
				return "#818181"
			case "PAID": return "#3ECB7F"
			case "VOIDED": return "#E14C44"
			default: return ""
		}
	}

	get total(): string {
		return this.invoice.total
	}

	openLog(log: ServiceRecordDTO) {
		this.$emit("log", log)
	}
	private formatDate(date: Date): string {
		return moment(date).format("MMM D");
	}

}
